import type { TabBlockProps } from '~/editor/blocks/tab/TabBlockProps';
import MicrositeSection from '~/components/MicrositeSection';
import styled from '@emotion/styled';
import { css_gap, css_small_down, css_text } from '~/emotion/theme';
import { useState } from 'react';
import useIsGrid from '~/hooks/useIsGrid';

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	min-height: 10rem;
	padding: ${css_gap('content')} 0;
`;

const Tabs = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
	gap: ${css_gap('content')};
	margin-bottom: ${css_gap('content')};

	@media (${css_small_down}) {
		justify-content: space-evenly;
	}
`;

const Tab = styled.a<{ active: boolean }>`
	font-size: 1.2rem;
	font-weight: 500;
	padding: 0.5rem 1rem;
	border-bottom-width: 2px;
	border-bottom-style: solid;
	cursor: pointer;
	color: ${(props) => (props.active ? css_text() : css_text('weak'))};
	border-bottom-color: ${(props) => (props.active ? css_text() : 'transparent')};

	&:hover {
		border-bottom-color: ${css_text('weak')};
	}
`;

const ActiveTab = styled.div`
	min-height: 10rem;
	width: 100%;
`;

export default function TabBlockAlpha({ tabs, ref }: TabBlockProps) {
	const [activeIndex, setActiveIndex] = useState(0);
	const isGrid = useIsGrid();
	const active = tabs[activeIndex] ?? tabs[0] ?? <></>;

	const content = (
		<Wrapper>
			<Tabs ref={ref}>
				{tabs.map((tab, index) => (
					<Tab key={tab.name} onClick={() => setActiveIndex(index)} active={activeIndex === index}>
						{tab.name}
					</Tab>
				))}
			</Tabs>
			<ActiveTab>{active.content}</ActiveTab>
		</Wrapper>
	);

	if (isGrid) {
		return content;
	}

	return <MicrositeSection fill>{content}</MicrositeSection>;
}
